import { MarkerDataModel } from '@/models/marker/marker';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ECPA_RULES } from '@/utils/constants';

@Component({
    name: 'ecpa-info',
})

export default class ECPAInfoComponent extends Vue {

    // --------------------------------------------------------
    // Properties

    @Prop()
    private showcaseData!: MarkerDataModel;

    private get ecpaRules() {
        const { context } = this.showcaseData;
        return context.ecpaRules;

    }

    private publisherList: any = ECPA_RULES;

    // --------------------------------------------------------
    // Hooks

    // --------------------------------------------------------
    // Actions

    private onSelectPublisher(publisher: any) {
        publisher.isActive = !publisher.isActive;
        const { context } = this.showcaseData;
        if (context.ecpaRules.indexOf(publisher.rule_id) !== -1) {
            context.ecpaRules = context.ecpaRules.filter((item: any) => item !== publisher.rule_id);
        } else {
            context.ecpaRules.push(publisher.rule_id);
        }
    }

}
